
import React from 'react';

const HoursAndLocation: React.FC = () => {
  const hours = [
    { day: "Monday", time: "8:00am - 5:30pm", notes: "Appts & Walk-ins" },
    { day: "Tue - Fri", time: "8:00am - 5:30pm", notes: "Appts & Walk-ins" },
    { day: "Saturday", time: "8:00am - 2:00pm", notes: "Walk-ins & Appts" },
    { day: "Sunday", time: "8:00am - 2:00pm", notes: "Call Ahead & Walk-ins" }
  ];

  return (
    <section id="location" className="py-24 bg-stone-900 text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          
          <div className="space-y-12">
            <div>
              <h2 className="text-5xl font-serif font-bold mb-4">Visit The Shop</h2>
              <p className="text-red-500 font-bold uppercase tracking-[0.2em]">601 N Ridge Rd, Wichita, KS 67212</p>
              <p className="text-stone-400 mt-2 italic font-serif">Established 1992 — Over 100 Years of Combined Experience</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="p-6 bg-stone-800 rounded-none border border-stone-700 shadow-xl">
                <h4 className="text-xs uppercase tracking-widest font-bold mb-4 text-stone-500">Contact Lines</h4>
                <div className="space-y-4">
                  <div>
                    <p className="text-xs text-stone-400 uppercase mb-1">Primary</p>
                    <a href="tel:3167218600" className="text-xl font-bold text-red-500 hover:text-red-400 transition-colors block">
                      (316) 721-8600
                    </a>
                  </div>
                  <div>
                    <p className="text-xs text-stone-400 uppercase mb-1">Secondary</p>
                    <a href="tel:3167298303" className="text-xl font-bold text-red-500 hover:text-red-400 transition-colors block">
                      (316) 729-8303
                    </a>
                  </div>
                </div>
              </div>
              <div className="p-6 bg-stone-800 rounded-none border border-stone-700 shadow-xl flex flex-col justify-center">
                <h4 className="text-xl font-serif font-bold mb-2 text-white">Location</h4>
                <p className="text-stone-300">Ridge & Central — The heart of the West Side.</p>
                <p className="text-stone-500 text-sm mt-4 italic">"Look for the traditional poles."</p>
              </div>
            </div>

            <div className="bg-white text-stone-900 p-8 rounded-none shadow-2xl relative overflow-hidden">
               <div className="absolute top-0 left-0 w-full h-2 barber-pole"></div>
               <h4 className="text-2xl font-serif font-bold mb-6 text-center border-b border-stone-100 pb-4 uppercase tracking-widest">Shop Hours</h4>
               <table className="w-full text-lg">
                 <tbody>
                   {hours.map((h, i) => (
                     <tr key={i} className="border-b border-stone-100 last:border-0 hover:bg-stone-50 transition-colors">
                       <td className="py-3 font-bold">{h.day}</td>
                       <td className="py-3 text-stone-600">{h.time}</td>
                       <td className="py-3 text-xs uppercase tracking-tighter text-red-700 font-black text-right">{h.notes}</td>
                     </tr>
                   ))}
                 </tbody>
               </table>
               <div className="mt-6 pt-6 border-t border-stone-100 text-center">
                 <p className="text-3xl font-serif italic font-bold text-stone-800 tracking-tight">OPEN 7 DAYS A WEEK</p>
               </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="bg-stone-800 p-2 rounded-none shadow-2xl overflow-hidden h-[500px] border-4 border-stone-700">
               <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3155.088891585642!2d-97.43322692411874!3d37.691717872013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87bae13710b10001%3A0x6d9f75d56b0d1e3!2s601%20N%20Ridge%20Rd%2C%20Wichita%2C%20KS%2067212!5e0!3m2!1sen!2sus!4v1709212345678!5m2!1sen!2sus" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen={true} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                className="grayscale contrast-125 invert-[0.1]"
              ></iframe>
            </div>
            <div className="text-center">
              <p className="text-stone-500 font-serif italic">"Park right out front. We're easy to find on the West Side."</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HoursAndLocation;
